import { routes } from './index';

const campaignMenu = Object.freeze({
  menuItems: [
    {
      name: 'Campaign',
      path: routes.CAMPAIGN_CREATE,
      editPath: routes.CAMPAIGN_EDIT,
      options: [
        {
          iconName: 'create-ad',
          title: 'Create new ad set',
          action: 'create',
        },
      ],
      submenuItems: [
        {
          name: 'Name',
          fragment: 'campaign-name',
          path: routes.CAMPAIGN_CREATE,
          editPath: routes.CAMPAIGN_EDIT,
        },
        {
          name: 'Objective',
          fragment: 'objective',
          path: routes.CAMPAIGN_CREATE,
          editPath: routes.CAMPAIGN_EDIT,
        },
        {
          name: 'Charity',
          fragment: 'charity',
          path: routes.CAMPAIGN_CREATE,
          editPath: routes.CAMPAIGN_EDIT,
        },
      ],
    },
    {
      name: 'Ad Set',
      path: routes.SPONSORSHIP_SET_CREATE,
      editPath: routes.SPONSORSHIP_SET_EDIT,
      options: [
        {
          iconName: 'create-ad',
          title: 'Create new ad',
          action: 'create',
        },
        {
          iconName: 'duplicate-ad',
          title: 'Duplicate ad set',
          action: 'duplicate',
        },
        {
          iconName: 'delete-ad',
          title: 'Delete ad set',
          action: 'delete',
        },
      ],
      submenuItems: [
        {
          name: 'Name',
          fragment: 'adset-name',
          path: routes.SPONSORSHIP_SET_CREATE,
          editPath: routes.SPONSORSHIP_SET_EDIT,
        },
        {
          name: 'Audience',
          fragment: 'audience',
          path: routes.SPONSORSHIP_SET_CREATE,
          editPath: routes.SPONSORSHIP_SET_EDIT,
        },
        {
          name: '8Pixel',
          fragment: '8pixel',
          path: routes.SPONSORSHIP_SET_CREATE,
          editPath: routes.SPONSORSHIP_SET_EDIT,
        },
        {
          name: 'Timing',
          fragment: 'timing',
          path: routes.SPONSORSHIP_SET_CREATE,
          editPath: routes.SPONSORSHIP_SET_EDIT,
        },
        {
          name: 'Budget',
          fragment: 'budget',
          path: routes.SPONSORSHIP_SET_CREATE,
          editPath: routes.SPONSORSHIP_SET_EDIT,
        },
      ],
    },
    {
      name: 'Ad',
      path: routes.SPONSORSHIP_CREATE,
      editPath: routes.SPONSORSHIP_EDIT,
      options: [
        {
          iconName: 'duplicate-ad',
          title: 'Duplicate ad',
          action: 'duplicate',
        },
        {
          iconName: 'delete-ad',
          title: 'Delete ad',
          action: 'delete',
        },
      ],
      submenuItems: [
        {
          name: 'Ad Name',
          fragment: 'ad-name',
          path: routes.SPONSORSHIP_CREATE,
          editPath: routes.SPONSORSHIP_EDIT,
        },
        {
          name: 'Creative',
          fragment: 'creative',
          path: routes.SPONSORSHIP_CREATE,
          editPath: routes.SPONSORSHIP_EDIT,
        },
        {
          name: 'Questions',
          fragment: 'questions',
          path: routes.SPONSORSHIP_CREATE,
          editPath: routes.SPONSORSHIP_EDIT,
        },
        {
          name: 'Call to action',
          fragment: 'action',
          path: routes.SPONSORSHIP_CREATE,
          editPath: routes.SPONSORSHIP_EDIT,
        },
      ],
    },
    {
      name: 'Summary',
      path: routes.CAMPAIGN_SUMMARY,
      editPath: routes.CAMPAIGN_SUMMARY,
      submenuItems: [],
    },
  ],
});

export default campaignMenu;
